import { __module as defineProperty } from './_virtual-defineProperty.js';
import { __require as requireToPropertyKey } from './node_modules-@babel-runtime-helpers-toPropertyKey.js';

var hasRequiredDefineProperty;

function requireDefineProperty () {
	if (hasRequiredDefineProperty) return defineProperty.exports;
	hasRequiredDefineProperty = 1;
	(function (module) {
		var toPropertyKey = requireToPropertyKey();
		function _defineProperty(e, r, t) {
		  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
		    value: t,
		    enumerable: true,
		    configurable: true,
		    writable: true
		  }) : e[r] = t, e;
		}
		module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (defineProperty));
	return defineProperty.exports;
}

export { requireDefineProperty as __require };
//# sourceMappingURL=node_modules-@babel-runtime-helpers-defineProperty.js.map
